<script setup lang="ts">
import BackstageButton from '@/components/common/BackstageButton.vue';
import { useI18n } from 'vue-i18n';

export interface AccountItem {
  accountId: string;
  accountName: string;
  draftNumbers?: string[];
}

export interface Props {
  items: AccountItem[];
}

const props = defineProps<Props>();

const { t } = useI18n();
const emit = defineEmits(['close-popup']);

function closePopup() {
  emit('close-popup', true);
}
</script>

<template>
  <div class="view-orders-duplication-details">
    <ul class="view-items account-list">
      <li v-for="item in props.items" :key="item.accountId" class="account-list-item">
        <div class="account-item">
          <div class="account-name">{{ item.accountName }}</div>
          <div v-if="item.draftNumbers" class="draft-numbers">
            <label
              v-for="draftNumber in item.draftNumbers"
              :key="item.draftNumbers.indexOf(draftNumber)"
              data-cy="account-item-note">
              {{ draftNumber }}
            </label>
          </div>
        </div>
      </li>
    </ul>
    <div class="footer">
      <BackstageButton v-on:click="closePopup()">
        {{ t('global.ok_got_it') }}
      </BackstageButton>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@mixin flex-cnt {
  display: flex;
  gap: 12px;
}

.footer {
  margin-top: 20px;
  position: absolute;
  right: 44px;
  bottom: 30px;
}

.view-orders-duplication-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.view-items {
  max-width: fit-content;
}

.account-list {
  list-style: none;
  padding: 0;
}

.account-list-item {
  display: flex;
  margin-bottom: 10px;
}

.account-item {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  width: fit-content;
  margin-bottom: 10px;

  .account-name {
    display: flex;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .draft-numbers {
    display: flex;
    flex-direction: column;
    width: fit-content;
    color: var(--primary-label-input-color);
  }
}
</style>
